import {Component, ElementRef, EventEmitter, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Channel} from '../signup/signup.component';
import {SmsVerificationComponent} from '../sms-verification/sms-verification.component';
import {AccountVerificationService} from 'src/app/account-verification.service';
import {mobile} from '../../consts/utilities';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {phoneRegex} from '../../consts/regex-patterns.consts';
import {AuthInputComponent} from '../../shared-components/auth-input/auth-input.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

    @ViewChild('SmsPasswordReset', { static: true })
    passwordResetCmp: SmsVerificationComponent;

    @ViewChild('resetContainer', { static: true })
    viewElement: ElementRef<any>;

    public isMobile: boolean;
    waiting = false;

    channel: Channel;

    public accountForm = new FormGroup({
        pais: new FormControl(52, []),
        account: new FormControl('', [])
    });

    user: string;
    zIndexParam: string;

    notSuccessReset = false;

    userIsOnEnteringData = true;
    userCanEnterPassword = false;

    now = new Date().getFullYear();

    @ViewChild('authInput', { static: false })
    authInput: AuthInputComponent;

    @ViewChild('confirmationCode', { static: true })
    confirmationCodeTempl: TemplateRef<any>;

    @Output() userCancelRecovery = new EventEmitter();
    @Output() userCompletedRecovery = new EventEmitter();

    constructor(
        private accountVerificationService: AccountVerificationService,
        private router: Router,
        private snackbar: MatSnackBar,
        private dialog: MatDialog,
        private bottom: MatBottomSheet,
    ) { }

    ngOnInit() {
        this.isMobile = mobile();

        this.observeAccountPattern();
    }

    private observeAccountPattern(): void {
        this.accountForm.get('account').valueChanges.subscribe(
            newValue => {
                this.channel = (phoneRegex.test(newValue))
                    ? Channel.WhatsApp
                    : Channel.Email;
            }
        );
    }

    postPasswordReset(): void {
        this.notifyUserCodeSendProcess(() => {
            const { account: _account } = this.accountForm.value;
            let account = _account;

            if (this.accountForm.invalid) {
                return;
            }

            if (this.channel === Channel.SMS || this.channel === Channel.WhatsApp) {
                const country = this.accountForm.value.pais;
                account = `${country}${account}`;
            }

            this.user = account;

            this.resetAccount(account);

            this.waiting = true;
        });
    }

    onSmsPasswordResetState(resetIsOk: boolean) {
        if (resetIsOk) {
            this.router.navigate(['account']);
        }

        if (!resetIsOk) {
            this.notSuccessReset = true;
        }
    }

    private resetAccount(account: string): void {
        this.accountVerificationService.sendRecoveryCode(account, this.channel).subscribe(
            response => this.onResetAccountResponse(response),
            error => this.onResetAccountError(error)
        );
    }

    private onResetAccountResponse(response: any): void {
        const { data, statusCode } = response;
        const { userId } = data;

        if (statusCode === 204) {
            this.snackbar.open('No se encontró la cuenta, favor de utilizar el número de teléfono o correo con el que se registro.', 'CERRAR', {
                duration: 8000,
                horizontalPosition: 'center',
                verticalPosition: 'bottom'
            });
        } else {
            let user = this.accountForm.get('account').value;

            if (this.channel === Channel.SMS || this.channel === Channel.WhatsApp) {
                const country = this.accountForm.value.pais;
                user = `${country}${user}`;
            }

            this.userIsOnEnteringData = false;

            this.passwordResetCmp.open({
                id: userId,
                account: user,
                channel: this.channel,
                state: 'sendingCode',
                typeOfVerification: 'non-signup',
                isForReset: true
            });

            this.storeTemporaryToken(response.token);
        }
    }

    private onResetAccountError(error: Error): void {
        console.log(error);
    }

    onUserVerifiedCode(event: any): void {
        this.userIsOnEnteringData = false;
        this.userCanEnterPassword = true;
    }

    onPasswordResetted(event: any): void {
        this.userCompletedRecovery.emit();
    }

    public changeCodeChannelToSMS(): void {
        this.channel = Channel.SMS;
        this.dismissNotifications();
    }

    public dismissNotifications(): void {
        if (mobile()) {
            this.bottom.dismiss();
        }

        if (!mobile()) {
            this.dialog.closeAll();
        }
    }

    private notifyUserCodeSendProcess(onClosed: () => void): void {
        if (this.channel === Channel.Email) {
            onClosed();
            return;
        }

        let notification: MatDialogRef<any> | MatBottomSheetRef;

        if (mobile()) {
            notification = this.bottom.open(this.confirmationCodeTempl);
            notification.afterDismissed().subscribe(() => onClosed());
        }

        if (!mobile()) {
            notification = this.dialog.open(this.confirmationCodeTempl);
            notification.afterClosed().subscribe(() => onClosed());
        }
    }

    private storeTemporaryToken(token: string): void {
        sessionStorage.setItem('temporal_access_token', token);
    }
}
